import { useNavigate } from "react-router";

import { Button } from "@/ui";

function SignInButton() {
  const navigate = useNavigate();

  const signIn = () => {
    navigate("/login");
  };

  return (
    <Button variant="gradient" onClick={signIn}>
      Sign In
    </Button>
  );
}

export default SignInButton;
